import * as meshPhongShaders from "./meshPhong";
import * as meshBasicShaders from "./meshBasic";
import * as meshStandardShaders from "./meshStandard";
import * as pointCloudShaders from "./pointCloud";
import * as lineShaders from "./line";
import * as spriteShaders from "./sprite";
import * as glyphShaders from "./glyph";
export const Shaders = {
    pointCloud: {
        vertex: pointCloudShaders.baseVertex,
        fragment: pointCloudShaders.baseFragment,
    },
    pointCloudIntensity: {
        vertex: pointCloudShaders.baseVertex,
        fragment: pointCloudShaders.intensityFragment,
    },
    pointCloudClassification: {
        vertex: pointCloudShaders.baseVertex,
        fragment: pointCloudShaders.classificationFragment,
    },
    pointCloudGradient: {
        vertex: pointCloudShaders.baseVertex,
        fragment: pointCloudShaders.gradientFragment,
    },
    meshPhong: {
        vertex: meshPhongShaders.baseVertex,
        fragment: meshPhongShaders.baseFragment,
    },
    meshBasic: {
        vertex: meshBasicShaders.baseVertex,
        fragment: meshBasicShaders.baseFragment,
    },
    meshStandard: {
        vertex: meshStandardShaders.baseVertex,
        fragment: meshStandardShaders.baseFragment,
    },
    line: {
        vertex: lineShaders.baseVertex,
        fragment: lineShaders.baseFragment,
    },
    sprite: {
        vertex: spriteShaders.baseVertex,
        fragment: spriteShaders.baseFragment,
    },
    glyph: {
        vertex: glyphShaders.baseVertex,
        fragment: glyphShaders.baseFragment,
    },
};
